import { Component, Vue } from "vue-property-decorator";
import izitoast from "izitoast";
import Spinner from "@/components/Spinner.vue";
import StatusBadge from "@/components/StatusBadge.vue";
import AdtModalConfirm from "@/components/AdtModalConfirm.vue";
import AdtModalContent from "@/components/AdtModalContent.vue";
import AdtPagination from "@/components/communs/Pagination.vue";
import Helpers from "@/helpers/helpers";
import { DeserializedFileByIdRequest } from "@/models/Reconciliation/reconciliationFile.interface";
import { DeserializedRegistersResponse } from "@/models/Reconciliation/reconciliationRegister.interface";

@Component({
  components: {
    Spinner,
    "status-badge": StatusBadge,
    AdtModalConfirm,
    AdtModalContent,
    AdtPagination,
  },
})
export default class FileDetails extends Vue {
  private isLoading = false;
  private parameters: DeserializedFileByIdRequest = {
    deserializedFileId: "",
    deserializedRegistersCurrentPage: 1,
    deserializedRegistersPageSize: 10,
    status:''
  };
  private deserializedFile: any = [];
  private deserializedRegisters: DeserializedRegistersResponse[] = [];
  private totalDeserializedRegisters = 0;
  private errorMessage = '';
  private currentRegister: DeserializedRegistersResponse = {
    //@ts-ignore
    content: {},
    creationDate: "",
    deserializedFileId: "",
    deserializedRegisterId: "",
    fileSource: "",
    status: "",
  };
  private isContentCopied = false;

  get reconciliationRegisterStatus() {
    return [
      {key:0, name:'Todos'},
      {key:3, name:'Processados'},
      {key:4, name:'Processado com Erros'}
    ]
  }

  private getFileStatus() {
    return Helpers.reconciliationFileStatus;
  }

  private getRegisterStatus() {
    return Helpers.reconciliationRegisterStatus;
  }

  private created() {
    this.parameters.deserializedFileId = this.$route.params.id as string;

    this.$route.query.deserializedRegistersCurrentPage !== undefined &&
    this.$route.query.deserializedRegistersCurrentPage > "1"
      ? (this.parameters.deserializedRegistersCurrentPage = Number(
          this.$route.query.deserializedRegistersCurrentPage,
        ))
      : (this.parameters.deserializedRegistersCurrentPage = 1);

    this.addParamsToQuerystring(this.parameters);
    this.getDeserializedFileById(this.parameters);
  }

  private addParamsToQuerystring(parameters: DeserializedFileByIdRequest) {
    //@ts-ignore
    this.$router.replace({ ...this.$router.currentRoute, query: parameters }).catch(() => {});
  }

  private searchStatus(value: string) {
    this.parameters.status = value;
    this.onSearchBox();
  }

  private onSearchBox() {
    this.changePage(1);
    this.addParamsToQuerystring(this.parameters);
  }

  private changePage(page: number) {
    this.parameters.deserializedRegistersCurrentPage = page;
    this.addParamsToQuerystring(this.parameters);
    this.getDeserializedFileById(this.parameters);
  }

  private perPage(e: number) {
    this.parameters.deserializedRegistersPageSize = e;
    this.addParamsToQuerystring(this.parameters);
    this.getDeserializedFileById(this.parameters);
  }

  private toggleModal(name: string, register: any) {
    this.currentRegister = { ...register };
    // @ts-ignore
    this.$refs[name].toggle();
  }

  private toggleConfirmModal(name: string) {
    // @ts-ignore
    this.$refs[name].toggle();
  }

  private copyContent(elementId: string) {
    Helpers.copyDivContentOnClick(elementId);
    this.isContentCopied = true;

    setTimeout(() => {
      if (this.isContentCopied === true) this.isContentCopied = false;
    }, 2000);
  }

  private rowNumber(index: number) {
    if (
      this.parameters.deserializedRegistersCurrentPage &&
      this.parameters.deserializedRegistersPageSize !== undefined
    ) {
      return (
        (this.parameters.deserializedRegistersCurrentPage - 1) *
          this.parameters.deserializedRegistersPageSize +
        (index + 1)
      );
    }
  }

  private getDeserializedFileById(params: DeserializedFileByIdRequest) {
    this.isLoading = true;
    this.$store.dispatch("reconciliation/GET_DESERIALIZED_FILE_BY_ID", params).then((res: any) => {
      this.isLoading = false;
      this.deserializedFile = res.data.deserializedFile;
      this.deserializedRegisters = res.data.deserializedRegisters;
      this.totalDeserializedRegisters = res.data.totalDeserializedRegisters;
    });
  }

  private reprocessDeserializedFile() {
    this.isLoading = true;
    this.$store
      .dispatch("reconciliation/REPROCESS_DESERIALIZED_FILE", this.parameters.deserializedFileId)
      .then((res: any) => {
        izitoast.success({
          title: "Arquivo reprocessado com sucesso!",
          position: "bottomRight",
        });
      })
      .catch((err) => {
        izitoast.error({
          title: "Erro:",
          message: err,
          position: "bottomRight",
        });
      })
      .finally(() => {
        this.isLoading = false;
        this.toggleConfirmModal("confirmFileReprocess");
        this.getDeserializedFileById(this.parameters);
      });
  }

  private reprocessDeserializedRegister() {
    this.isLoading = true;
    this.$store
      .dispatch(
        "reconciliation/REPROCESS_DESERIALIZED_REGISTER",
        this.currentRegister.deserializedRegisterId,
      )
      .then((res: any) => {
        this.toggleModal("fileContentModal", this.currentRegister);
        izitoast.success({
          title: "Linha reprocessada com sucesso!",
          position: "bottomRight",
        });
      })
      .catch((err) => {
        izitoast.error({
          title: "Erro:",
          message: err,
          position: "bottomRight",
        });
      })
      .finally(() => {
        this.isLoading = false;
        this.getDeserializedFileById(this.parameters);
      });
  }

  private showFile(data: any) {
    const linkSource = `data:application/pdf;base64,${data.documentContent}`;
    const downloadLink = document.createElement("a");
    const fileName = data.documentName;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  private downloadDeserializedFile() {
    this.$store
      .dispatch("reconciliation/DOWNLOAD_DESERIALIZED_FILE", this.parameters.deserializedFileId)
      .then((res) => {
        this.showFile(res.data);
      })
      .catch((err) => {
        izitoast.error({
          title: "Erro:",
          message: err,
          position: "bottomRight",
        });
      });
  }

  private replaceDeserializedFile() {
    this.$router.push({
      name: "replace-file",
      query: {
        fileId: this.parameters.deserializedFileId,
      },
    });
  }

  private formatContentOnDisplay(content: any) {
    return JSON.stringify(content).substring(0, 50) + "...";
  }

  private formatContentErrorMessageOnDisplay(content: any) {
    return JSON.stringify(content).substring(0, 50) + "...";
  }

  private showErrorMessageModal(item: any) {
    this.errorMessage = item;
    //@ts-ignore
    this.toggleModal("contentErrorMessageModal");
  }

  private formatRegisterContentOnDisplay(content: any) {
    const newContent = JSON.stringify(content, null, 2)
    return newContent.replace(/{|}/g, '')
  }
}
